const config = {
  vuexStorageKeys: [
    'sessionToken'
  ],
  plugins: [
    'tk',
    'device',
    'vuexStorage',
    'user',
    'index',
    'routerAuth'
  ],
  navTheme: 'light', // 导航主题: dark 或 light
  layoutMode: 'sidemenu', // 布局类型：sidemenu 或 topmenu
  contentWidth: 'Fluid', // 内容布局类型，Fluid 或 Fixed
  fixedHeader: true, // 是否固定头部
  fixSidebar: true, // 是否固定左侧导航栏
  projectName: '新乐村村通管理后台',
  // apiUrl: 'http://localhost:3333',
  apiUrl: 'https://cloud.xinle.mokekeji.com',
  appID: 'S2MuDFkfsfhwb3LUQwvPWlBrmui14cfO',
  masterKey: 'YtocT4h6iAIpKnSm2DUwEsJP7YHSMXvT',
  restKey: '',
  modelJSON: require('./assets/json/model'),
  iconJSON: require('./assets/json/icon')
}
export default config
